// import 'core-js/es/symbol'
// import 'core-js/es/set'
// import 'core-js/es/map'
import './index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './redux'

window.onerror = function (message, source, lineno, colno, error) {
    const errMsg = JSON.stringify({ message, source, lineno, colno, error })
    console.error(errMsg)
}
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
